module.exports = __webpack_public_path__ + "static/media/Acceptus use telemedicine software for digital healthcare.921331b2.webp";